import $ from 'jquery';
import difference from 'lodash/difference';
import layout from '~/js/services/layout';
import scroller from '~/js/services/scroller';


const observer = function (options) {
    let o, m, internal, elements, fn, handlers;


    o = $.extend({
        $e: null,
        selector: ''
    }, options);


    m = observer.markup;


    internal = {
        $e: o.$e || $(o.selector),
        intersecting: [],
        observerTop: 0,
        observerMaxY: 0
    };


    elements = {
        observed: $(`[data-observer="${internal.$e.attr('id')}"]`)
    };


    fn = {
        init () {
            scroller.onScroll(handlers.viewportChanged);
            layout.onResize(handlers.viewportChanged);

            // browser scroll might not be final on DOM load so wait a tick
            setTimeout(fn.detectObserved);
        },

        isIntersecting ($el) {
            const elTop = $el.offset().top;
            const elMaxY = elTop + ($el.innerHeight() / 2);
            const intersectingY = internal.observerMaxY >= elMaxY && elMaxY >= internal.observerTop;

            return intersectingY;
        },

        detectObserved () {
            internal.observerTop = internal.$e.offset().top;
            internal.observerMaxY = internal.observerTop + internal.$e.innerHeight();

            const newIntersecting = [];

            elements.observed.each((i, observed) => {
                if (fn.isIntersecting($(observed))) {
                    newIntersecting.push(observed);
                }
            });

            newIntersecting.forEach(el => {
                $(el).addClass(m.INTERSECTING);
            });

            difference(internal.intersecting, newIntersecting).forEach(el => {
                $(el).removeClass(m.INTERSECTING);
            });

            internal.intersecting = newIntersecting;
        }
    };


    handlers = {
        viewportChanged () {
            fn.detectObserved();
        }
    };


    fn.init();
};


observer.markup = {
    // dom selector
    CONTAINER: 'observer',

    // states
    INTERSECTING: 'state-intersecting'
};


export default observer;



// WEBPACK FOOTER //
// ./assets/js/components/observer.js